import * as React from "react";
import {observer} from "mobx-react";
import ISelectOption from "../ComponentsTypes";
import FormMultipleSelectOption from "./FormMultipleSelectOption";
import FormInput from "../FormInput/FormInput";


interface IProps {
    selectOptions: ISelectOption[],
    isDisabled: boolean,
    getSelectedValues: (res: string[]) => void
    finishStepInFormCB?: (val: boolean) => void
}

interface ILocalState {
    checkedOptions: boolean[],
    otherText: string
}

@observer
export default class FormMultipleSelect  extends React.Component<
    IProps, ILocalState
    > {
    constructor (props: IProps) {
        super(props);
        const initialArray: boolean[] = [];
        props.selectOptions.forEach(() => initialArray.push(false));
        this.state = {checkedOptions: initialArray, otherText: ""}
    }

    public render() {
        return (<>{this.renderOptions()}</>);
    }

    private renderOptions = () => {
        const options = this.props.selectOptions;
        const checkedOptions = this.state.checkedOptions;
        return options.map((option, index) => {
            return <>
                <div key={index} onClick={this.optionClick.bind(this, index)}><FormMultipleSelectOption isChecked={checkedOptions[index]} optionPros={option}/></div>
                {this.renderFreeTextIfNeeded(option, checkedOptions[index])}
            </>
        });
    }

    private optionClick = (index: number) => {
        if(this.props.isDisabled) {
            return;
        }
        const newState = this.state;
        newState.checkedOptions[index] = !newState.checkedOptions[index];
        this.setState(newState);
        this.props.getSelectedValues(this.getCheckedOptions());
        if(this.props.finishStepInFormCB) {
            const oneOptionAtLeastSelected = this.state.checkedOptions.filter(v => v).length > 0;
            this.props.finishStepInFormCB(oneOptionAtLeastSelected);
        }
    };

    private renderFreeTextIfNeeded = (option: ISelectOption, isChecked: boolean) => {
        if(option.value === "Other" && isChecked) {
            return <FormInput placeholder={"Please specify..."} change={this.onChange}/>
        }
        return null;
    };

    private onChange = (otherLoanPurposeTypeEvent: string) => {
        this.setState({otherText: "Other: " + otherLoanPurposeTypeEvent},  () => {
            this.props.getSelectedValues(this.getCheckedOptions());
        });
    };

    private getCheckedOptions = () => {
        const res: string[] = [];
        this.state.checkedOptions.forEach((checkmark, index) => {
            if (checkmark && this.props.selectOptions[index].value !== "Other") {
                res.push(this.props.selectOptions[index].value)
            }
        });
        if(this.state.otherText !== '') {
            res.push(this.state.otherText)
        }
        return res;
    };
}


// WEBPACK FOOTER //
// ./src/components/FormMultipleSelect/FormMultipleSelect.tsx